module.exports = __webpack_public_path__ + "static/media/stores.b765aab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stores.png
// module id = 91
// module chunks = 0